import React from "react";
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import { UnstiledReadonlyInput } from '../../common/Inputs';
import { getOrderItemTotal } from './OrderTotal';

let OrderItemTotal = ({ sum }) =>
    (<UnstiledReadonlyInput value={`${sum} р.`} />);

OrderItemTotal = connect((state, { index, services, formName }) => {
    const formValues = getFormValues(formName)(state);

    const sum = (formValues && formValues.Items && formValues.Items[index]) ?
        getOrderItemTotal(services, formValues.Items[index]) : 0;

    return { sum };

})(OrderItemTotal);

export default OrderItemTotal;


// WEBPACK FOOTER //
// ./src/components/orders/items/OrderItemTotal.jsx